import { Consent } from "../types/enums/consent.enum";

export const DEFAULT_CONSENT_OPTIONS = [
  Consent.ANALYTICS,
  Consent.PERFORMANCE,
  Consent.ADVERTISING,
];
